import React from "react";
import { SharedOwnedBusinessEntity } from "../../../shared/lib/types";

import { Box } from "../../../shared/components/ui/chakra";
import { HStack, Text } from "@chakra-ui/react";

const BusinessEntityStatusTag = ({
  businessEntity,
}: {
  businessEntity: Pick<
    SharedOwnedBusinessEntity,
    "is_active" | "is_rejected" |  "is_email_verified" | "applicationing"
  >;
}) => {
  const caution = {
    textColor: "text.caution.dark",
    backgroundColor: "background.caution",
  };
  const blue = {
    textColor: "tealBlue.base",
    backgroundColor: "tealBlue.light",
  };
  const gray = {
    textColor: "gray.base",
    backgroundColor: "gray.light",
  };

  const states = [];
  if (businessEntity.is_active === false) {
    states.push({
      color: gray,
      text: "掲載一時停止中",
    });
  }
  if (businessEntity.is_active === true) {
    if (businessEntity.applicationing) {
      states.push({
        color: blue,
        text: "掲載中 (再審査中)",
      });
    } else {
      states.push({
        color: blue,
        text: "掲載中",
      });
    }
  } else {
    if (businessEntity.applicationing) {
      states.push({
        color: gray,
        text: "審査中",
      });
    } else {
      states.push({
        color: gray,
        text: "審査前",
      });
    }
  }
  if (businessEntity.is_rejected) {
    states.push({
      color: caution,
      text: "修正必要",
    });
  }
  if (businessEntity.is_email_verified === false) {
    states.push({
      color: caution,
      text: "メール未認証",
    });
  }

  return (
    <HStack>
      {states.map((state, index) => (
        <Box px={2} width="fit-content" {...state.color} key={index}>
          <Text fontSize={"xs"}>{state.text}</Text>
        </Box>
      ))}
    </HStack>
  );
};

export default BusinessEntityStatusTag;
